"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.form.knowledge.show': 'Show knowledge entries',
    'avatar.form.knowledge.label': 'Knowledge Base Entries',
    'avatar.form.knowledge.search_placeholder': 'Search knowledge entries...',
    'avatar.form.knowledge.add': 'Add New Knowledge',
    'avatar.form.knowledge.fullscan': 'Full document scan',
    'avatar.form.title.edit': 'Edit Avatar',
    'avatar.form.title.add': 'Add Avatar',
    'avatar.form.back': 'Back',
    'avatar.form.name.label': 'Name',
    'avatar.form.name.placeholder': 'Avatar name',
    'avatar.form.gender.label': 'Gender',
    'avatar.form.gender.placeholder': 'Select gender',
    'avatar.form.gender.none': 'None',
    'avatar.form.gender.male': 'Male',
    'avatar.form.gender.female': 'Female',
    'avatar.form.age.label': 'Age',
    'avatar.form.age.placeholder': 'Enter avatar age',
    'avatar.form.voice.label': 'Voice',
    'avatar.form.voice.placeholder': 'Select voice',
    'avatar.form.voice.male': 'Male Voices',
    'avatar.form.voice.female': 'Female Voices',
    'avatar.form.logo.label': 'Avatar image',
    'avatar.form.logo.placeholder': 'Send avatar image',
    'avatar.form.instructionFile.label': 'Instruction File',
    'avatar.form.instructionFile.placeholder': 'Upload instruction file',
    'avatar.form.instructions.title': 'Instructions',
    'avatar.form.instructions.description': 'Manage instruction entries that guide the avatar\'s behavior. Each entry requires a file attachment and can also have notes and a prompt.',
    'avatar.form.error.instruction_file_required': 'Each instruction entry must have a file attached.',
    'avatar.form.instructions.add': 'Add Instruction',
    'avatar.form.instructions.empty': 'No instruction entries yet. Click "Add Instruction" to create one.',
    'avatar.form.instructions.untitled': 'Unnamed Layer',
    'avatar.form.instructions.layer.label': 'Layer',
    'avatar.form.instructions.layer.placeholder': 'Enter layer name',
    'avatar.form.instructions.notes.label': 'Notes',
    'avatar.form.instructions.notes.placeholder': 'Enter instruction notes',
    'avatar.form.instructions.prompt.label': 'Instruction Prompt',
    'avatar.form.instructions.prompt.placeholder': 'Enter instruction prompt',
    'avatar.form.instructions.file.label': 'Instruction File',
    'avatar.form.instructions.isPublic.label': 'Public (included in webhooks)',
    'avatar.form.instructions.file.placeholder': 'Upload instruction file',
    'avatar.form.instructions.files.label': 'Instruction Files',
    'avatar.form.instructions.files.placeholder': 'Upload instruction files',
    'avatar.form.instructions.versions.title': 'Version History',
    'avatar.form.instructions.versions.show': 'Show Version History',
    'avatar.form.instructions.versions.hide': 'Hide Version History',
    'avatar.form.instructions.versions.empty': 'No previous versions available.',
    'avatar.form.instructions.versions.restore': 'Restore',
    'avatar.form.instructions.versions.restore_confirm': 'Are you sure you want to restore this version? Current changes will be overwritten.',
    'avatar.form.description.label': 'Description',
    'avatar.form.description.placeholder': 'Enter avatar description',
    'avatar.form.model.label': 'AI Model',
    'avatar.form.model.placeholder': 'Select AI model',
    'avatar.form.knowledge.placeholder': 'Search knowledge entries...',
    'avatar.form.submit.update': 'Update Avatar',
    'avatar.form.submit.create': 'Create Avatar',
    'avatar.form.submit.saveAndReturn.update': 'Save Avatar & Return to List',
    'avatar.form.submit.saveAndReturn.create': 'Create Avatar & Return to List',
    'avatar.form.tab.configuration': 'Configuration',
    'avatar.form.tab.knowledge': 'Knowledge Base',
    'avatar.form.tab.instructions': 'Instructions',
    'avatar.form.tab.tools': 'Tools',
    'avatar.form.tab.webhooks': 'Webhooks',
    'avatar.form.tab.lexicon': 'Lexicon',
    'avatar.form.tab.rag': 'RAG Settings',
    'avatar.form.tab.apiTools': 'API Tools',
    'avatar.form.timed.label': 'Enable Time-based Availability',
    'avatar.form.timed.help': 'Restrict when this avatar is available',
    'avatar.form.startTime.label': 'Available From',
    'avatar.form.startTime.placeholder': 'Select start date',
    'avatar.form.endTime.label': 'Available Until',
    'avatar.form.endTime.placeholder': 'Select end date',
    'avatar.form.webhooks.config.title': 'Webhook Configuration',
    'avatar.form.webhooks.config.description': 'Configure authorization settings for all webhook endpoints',
    'avatar.form.webhooks.config.authHeader.label': 'Authorization Header',
    'avatar.form.webhooks.config.authHeader.placeholder': 'e.g., Authorization',
    'avatar.form.webhooks.config.authKey.label': 'Authorization Key',
    'avatar.form.webhooks.config.authKey.placeholder': 'Bearer token or API key',
    'avatar.form.webhooks.definitions.title': 'Webhook Definitions',
    'avatar.form.webhooks.definitions.add': 'Add Webhook',
    'avatar.form.webhooks.definitions.empty': 'No webhook definitions configured. Click "Add Webhook" to create one.',
    'avatar.form.webhooks.definitions.untitled': 'Untitled Webhook',
    'avatar.form.webhooks.definitions.name.label': 'Webhook Name',
    'avatar.form.webhooks.definitions.name.placeholder': 'Enter webhook name',
    'avatar.form.webhooks.definitions.address.label': 'Webhook URL',
    'avatar.form.webhooks.definitions.address.placeholder': 'https://your-endpoint.com/webhook',
    'avatar.form.webhooks.definitions.eventType.label': 'Event Type',
    'avatar.form.webhooks.definitions.cronInterval.label': 'Cron Interval',
    'avatar.form.webhooks.definitions.cronInterval.placeholder': '*/30 * * * *',
    'avatar.form.webhooks.definitions.cronInterval.help': 'Cron expression (e.g., */30 * * * * = every 30 minutes)',
    'avatar.form.webhooks.definitions.cronEnabled.label': 'Enable Cron',
    'avatar.form.webhooks.definitions.active.label': 'Active',
    'avatar.form.webhooks.definitions.authEnabled.label': 'Enable Authorization',
    'avatar.form.webhooks.definitions.authHeader.label': 'Authorization Header',
    'avatar.form.webhooks.definitions.authHeader.placeholder': 'e.g., Authorization',
    'avatar.form.webhooks.definitions.authKey.label': 'Authorization Key',
    'avatar.form.webhooks.definitions.authKey.placeholder': 'Bearer token or API key',
    'avatar.form.webhooks.payload.title': 'Payload Example',
    'avatar.form.webhooks.payload.subtitle': 'Example JSON payload for this webhook event type',
    'avatar.form.webhooks.payload.description': 'This is the structure of the JSON data that will be sent to your webhook endpoint.',
    'avatar.form.lexicon.title': 'Lexicon Entries',
    'avatar.form.lexicon.add': 'Add Entry',
    'avatar.form.lexicon.empty': 'No lexicon entries configured. Click "Add Entry" to create one.',
    'avatar.form.lexicon.untitled': 'Untitled Entry',
    'avatar.form.lexicon.hidden': 'Hidden',
    'avatar.form.lexicon.label.label': 'Label',
    'avatar.form.lexicon.label.placeholder': 'Enter term or word',
    'avatar.form.lexicon.value.label': 'Definition',
    'avatar.form.lexicon.value.placeholder': 'Enter definition or explanation',
    'avatar.form.lexicon.hidden.label': 'Hidden',
    'avatar.form.lexicon.hidden.help': 'When enabled, this entry will not be visible to users but will be used by the avatar for understanding',
    'avatar.form.apiTools.title': 'API Tools',
    'avatar.form.apiTools.description': 'Configure external API endpoints that the AI can call during conversations',
    'avatar.form.apiTools.enabled.label': 'Enable API Tools',
    'avatar.form.apiTools.enabled.help': 'Allow the avatar to make calls to external API endpoints',
    'avatar.form.apiTools.list.title': 'API Endpoints',
    'avatar.form.apiTools.add': 'Add Endpoint',
    'avatar.form.apiTools.empty': 'No API endpoints configured. Click "Add Endpoint" to create one.',
    'avatar.form.apiTools.untitled': 'Untitled Endpoint',
    'avatar.form.apiTools.name.label': 'Name',
    'avatar.form.apiTools.name.placeholder': 'Enter endpoint name',
    'avatar.form.apiTools.endpoint.label': 'Endpoint URL',
    'avatar.form.apiTools.endpoint.placeholder': 'https://api.example.com/endpoint',
    'avatar.form.apiTools.method.label': 'Method',
    'avatar.form.apiTools.description.label': 'Description',
    'avatar.form.apiTools.description.placeholder': 'Describe what this API endpoint does',
    'avatar.form.apiTools.description.help': 'A description helps the AI understand when and how to use this endpoint',
    'avatar.form.apiTools.authEnabled.label': 'Enable Authorization',
    'avatar.form.apiTools.authHeader.label': 'Authorization Header',
    'avatar.form.apiTools.authHeader.placeholder': 'e.g., Authorization',
    'avatar.form.apiTools.authKey.label': 'Authorization Key',
    'avatar.form.apiTools.authKey.placeholder': 'Bearer token or API key',
    'avatar.form.apiTools.authKey.toggle': 'Show/Hide key',
    'avatar.form.apiTools.payloadFields.title': 'Payload Fields',
    'avatar.form.apiTools.payloadFields.add': 'Add Field',
    'avatar.form.apiTools.payloadFields.description': 'Define the fields that AI will fill when calling this endpoint',
    'avatar.form.apiTools.payloadFields.empty': 'No payload fields defined. Click "Add Field" to create one.',
    'avatar.form.apiTools.payloadFields.name.label': 'Field Name',
    'avatar.form.apiTools.payloadFields.name.placeholder': 'e.g., query',
    'avatar.form.apiTools.payloadFields.desc.label': 'Field Description',
    'avatar.form.apiTools.payloadFields.desc.placeholder': 'Describe what this field is for so the AI knows how to fill it',
    'avatar.form.apiTools.payloadFields.type.label': 'Type',
    'avatar.form.apiTools.payloadFields.optional.label': 'Optional',
    'avatar.form.tools.title': 'Available Tools',
    'avatar.form.tools.description': 'Select which tools this avatar can use during conversations',
    'avatar.form.error.load_failed': 'Failed to load avatar',
    'avatar.form.error.model_required': 'AI model selection is required',
    'avatar.form.error.action_failed': 'Avatar action failed',
    'avatar.form.error.general_error': 'General error occurred while',
    'avatar.form.action.updated': 'updated',
    'avatar.form.action.created': 'created',
    'avatar.form.action.update': 'update',
    'avatar.form.action.create': 'create',
    'avatar.form.success.updated': 'Avatar updated successfully',
    'avatar.form.success.action_completed': 'Avatar action completed successfully',
};
